import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06c57840"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "shooting-create-pin-table__pin-status" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VIcon = _resolveComponent("VIcon")!

  return (_openBlock(), _createElementBlock("tr", {
    class: _normalizeClass(["shooting-create-pin-table__tr", { active: _ctx.active }]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click')))
  }, [
    _createElementVNode("td", null, _toDisplayString(_ctx.index), 1),
    _createElementVNode("td", _hoisted_1, [
      _createVNode(_component_VIcon, {
        icon: _ctx.panorama.pointId ? 'checked' : 'unchecked',
        class: "shooting-create-pin-table__pin-status-checked"
      }, null, 8, ["icon"])
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("img", {
        src: _ctx.panorama.thumbnail,
        class: "shooting-create-pin-table__thumbnail"
      }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("td", null, _toDisplayString(_ctx.panorama.filename), 1),
    _createElementVNode("td", null, _toDisplayString(_ctx.panorama.shootingDate), 1),
    (_ctx.showPlan)
      ? (_openBlock(), _createElementBlock("td", _hoisted_3, _toDisplayString(_ctx.plan), 1))
      : _createCommentVNode("", true)
  ], 2))
}